export default {
  Onboarding: {
    NEXT: 'Next Step',
    BACK: 'Back',
    FINISH: 'Finish Set-up',
    LATER: 'Set up later',
    Name: {
      HI: 'Hi',
      WELCOME:
        'Welcome to Mayday. Your journey to month-end accounting bliss starts today!',
      GET_STARTED: 'We just need a few bits to get you started.',
      NAME: 'First off, give your Group a name. This could be the primary business name, for instance.',
      NAME_GROUP: 'Please give your group a name',
      GROUP_NAME: 'Group name',
    },
    Entities: {
      TITLE: "Let's connect",
      CONNECT:
        'Now we can connect up your Xero organisations. We need you to add at least one in order to create your group.',
      CONNECT_QBO_ENABLED:
        'Now we can connect up your Xero organisations or QuickBooks companies. We need you to add at least one in order to create your group.',
      COLLECT_INFO:
        'Then, we can start collecting the relevant information from each of your connected Xero organisations.',
      COLLECT_INFO_QBO_ENABLED:
        'Then, we can start collecting the relevant information from each of your connected entities.',
      CONNECT_ORG_XERO: 'Connect a Xero Organisation',
      CONNECT_ORG_QBO: 'Connect a QuickBooks Company',
      CONNECTIONS: 'Connections',
    },
    Customisation: {
      TURN_ON: 'Turn on',
      CUSTOMISATION: 'Customisation',
      TITLE: 'How can we help?',
      PRODUCTS:
        "Let us know which products you'd like so we can tailor your Mayday experience.",
      PRODUCT_INFO:
        'Not sure which Mayday products are right for you? Find out more about them below:',
      ACCOUNT_CODES:
        "Not long now, we're just collecting the account codes from your Xero Organisations.",
      brag: {
        TITLE: 'BRAG',
        HEADLINE: 'Bank Reconciliation Across your Group',
        DESCRIPTION:
          "A Mayday browser extension on top of Xero's Bank Reconciliation screen, allowing you to reconcile payments in one Organisation to other Organisations in your group.",
      },
      recharger: {
        TITLE: 'Recharger',
        HEADLINE:
          'Automate the recharging of costs and revenues across and within the entities in your group',
        DESCRIPTION:
          'Create personalised recharge rules. Mayday Recharger will automatically pull through transactions and calculate your recharges, so you can one-click post them into Xero.',
      },
      balancer: {
        TITLE: 'Balancer',
        HEADLINE: 'Keep your intercompany balances in check',
        DESCRIPTION:
          'Mayday will monitor all your intercompany balances and show you where they fall out of balance. Post FX adjustments and Interest with one click.',
        MAPPINGS: 'Account Code Mappings',
      },
    },
    Products: {
      TITLE: 'Configuration',
    },
    Date: {
      TITLE: 'Start Date',
      SETUP: `Next up, we need to know the first month you\'ll want to use Mayday for. We\'ll only pull data from this month onwards. \n
      Don\'t worry if you're unsure about the exact date — you can easily change this later. `,
    },
    Extensions: {
      TITLE: 'Install our Extension',
      SUBTITLE:
        "Mayday BRAG extends the functionality of Xero's Bank Reconciliation page, and allows you to reconcile transactions across the organisations in your group. It does this with a browser Extension.",
      CHROME_STORE: 'Visit Mayday on the Chrome Web Store',
      EDGE_STORE: 'Visit Mayday on the Edge Add-ons Store',
    },
    Setup: {
      Balancer: {
        TITLE: 'Intercompany Balances',
        INSTRUCTIONS:
          'Add your intercompany balances below, selecting the entities and accounts involved. You can also choose which Mayday products the balances are used for and name them to differentiate balances between the same entities.',
        EDIT: "Don't have the details right now? You can also edit, delete and add intercompany balances later in the Settings.",
      },
    },
    Final: {
      TITLE: 'All set!',
      SUBTITLE: 'Welcome to the first day of the rest of your month end life!',
      RECHARGER_GUIDES:
        'Here are a couple of guides to creating rules and recharges which should be helpful:',
      RECHARGE_RULES: 'How to create Recharge Rules',
      RUN_CALCULATIONS: 'How to run Recharge Calculations',
      BRAG_GUIDES: 'Here are some guides to using BRAG:',
      BRAG_SETUP: 'BRAG Setup Guide',
      BRAG_USE: 'How to use BRAG',
      BALANCER_GUIDES: 'Here are some guides to using Balancer:',
      BALANCER_START: 'Balancer Quick Start Guide',
      FX_ADJUSTMENTS: 'Posting FX Adjustments',
      LOAN_INTEREST: 'Configuring Balance Interest',
      QUESTIONS:
        'If you have any more questions, please feel free to reach out using the chat bot in the bottom-right!',
      TEAM: 'Are you working as part of a team? You can invite them to this group from Settings > Team.',
      FINISH: "Let's go!",
    },
  },
};
